import { render, staticRenderFns } from "./BaseSearchForm.vue?vue&type=template&id=bb0c24a0&scoped=true&lang=pug"
import script from "./BaseSearchForm.vue?vue&type=script&lang=ts"
export * from "./BaseSearchForm.vue?vue&type=script&lang=ts"
import style0 from "./BaseSearchForm.vue?vue&type=style&index=0&id=bb0c24a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c24a0",
  null
  
)

export default component.exports